import React from 'react';
import { Grid } from '@material-ui/core';

import Pagination from '../Pagination';
import PaginationInput from '../PaginationInput';

import useStyles from './styles';

const PaginationWrapper = ({ length, page, setPage }) => {
  const classes = useStyles();

  if (length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Grid container className={classes.paginationWrapper}>
        <Grid item className={classes.paginationItem}>
          <span className={classes.paginationInfo}>Seite {page + 1} von {length}</span>
        </Grid>
        <Grid item className={classes.paginationItem}>
          <Pagination handlePageChanged={setPage} totalPageCount={length} currentPage={page}/>
        </Grid>
        <Grid item className={classes.paginationItem}>
          <PaginationInput
            handlePageChanged={setPage}
            totalPageCount={length}
            currentPage={page}
            label={'Seite aufrufen:'}/>
        </Grid>
      </Grid>
    </Grid>
  )
};

export default PaginationWrapper;